import { ElementsUsedByClient } from '@server/read-only-elements.consts';
import {
  Timer,
  Settings,
  Notification,
  Filter,
  Mail,
  Play,
  Automations,
  MathOperations,
  Cube,
  Assign,
  PlaybookAlert,
  Copy,
  Target,
  Hash,
  Path,
  Users,
  Clock,
} from '@sweep-io/sweep-design/dist/icons';
import { ReactNode } from 'react';
import { ConfigurationType } from '../../../../types';

export const propertiesToIcon: { [key: string]: ReactNode } = {
  name: <Hash size="medium" />,
  trigger: <Play size="medium" />,
  conditions: <Path size="medium" />,
  delay: <Timer size="medium" />,
  actions: <Automations size="medium" />,
  settings: <Settings size="medium" />,
  notification: <Notification size="medium" />,
  calculation: <MathOperations size="medium" />,
  filter: <Filter size="medium" />,
  lookup_relations: <Filter size="medium" />,
  field: <Cube size="medium" />,
  [ElementsUsedByClient.ASSIGNMENT_ASSIGN_TO]: <Assign size="medium" />,
  [ElementsUsedByClient.SEND_SLACK_MESSAGE]: <Notification size="medium" />,
  [ElementsUsedByClient.MET_CONDITIONS]: <Path size="medium" />,
  [ElementsUsedByClient.ASSIGNMENT_DO_NOT_NOTIFY]: <Notification size="medium" />,
  [ElementsUsedByClient.SEND_EMAIL]: <Mail size="medium" />,
  [ElementsUsedByClient.ASSIGNMENT_RULES]: <Users size="medium" />,
  [ElementsUsedByClient.UPDATE_RECORDS]: <Automations size="medium" />,
  [ElementsUsedByClient.CREATE_RECORD]: <Automations size="medium" />,
};

export const configurationItemTypeToIcon = {
  [ConfigurationType.sweepAssignment]: <Assign size="medium" />,
  [ConfigurationType.sweepAlert]: <PlaybookAlert size="medium" />,
  [ConfigurationType.sweepAutomation]: <Automations size="medium" />,
  [ConfigurationType.sweepDedupe]: <Copy size="medium" />,
  [ConfigurationType.sweepMatching]: <Target size="medium" />,
  [ConfigurationType.sweepScheduledAssignment]: <Clock size="medium" />,
};
